<!-- Loading component com SVG padronizado -->
<ng-container *ngIf="overlay; else inlineLoading">
  <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
    <img src="assets/img/Loading.svg" alt="Carregando..." [ngClass]="sizeClass" />
    <span *ngIf="text" class="mt-2 text-gray-600 text-sm">{{ text }}</span>
  </div>
</ng-container>

<ng-template #inlineLoading>
  <div class="inline-flex items-center justify-center">
    <img src="assets/img/Loading.svg" alt="Carregando..." [ngClass]="sizeClass" />
    <span *ngIf="text" class="ml-2 text-sm">{{ text }}</span>
  </div>
</ng-template>